export enum IndicatorBasedScreeningData {
  BearishTrendBasedOnTechnicalIndicator = 'BearishTrendBasedOnTechnicalIndicator',
  BearishTrendBasedOnCandlestickPattern = 'BearishTrendBasedOnCandlestickPattern',
  BullishTrendBasedOnCandlestickPattern = 'BullishTrendBasedOnCandlestickPattern',
  BullishTrendBasedOnTechnicalIndicator = 'BullishTrendBasedOnTechnicalIndicator',
  BullishHeikinAshi = 'HeikinAshiBullish',
  BearishHeikinAshi = 'HeikinAshiBearish',
}

export enum PriceOrVolumeScreening {
  EMACross50200Bearish = 'EMACross50200Bearish',
  EMACross50200Bullish = 'EMACross50200Bullish',
  SMAEMACrossBearish = 'SMAEMACrossBearish',
  SMAEMACrossBullish = 'SMAEMACrossBullish',
  MarketPriceAtFloorPrice = 'MarketPriceAtFloorPrice',
  Near52WeeksHigh = 'Near52WeeksHigh',
  Near52WeeksLow = 'Near52WeeksLow',
}

export enum FinancialScreening {
  CompanyAtProfitInLastFinancialYear = 'CompanyAtProfitInLastFinancialYear',
  CompanyLosingProfitInLastFinancialYear = 'CompanyLosingProfitInLastFinancialYear',
  CompanyAtLossInLastFinancialYear = 'CompanyAtLossInLastFinancialYear',
  LowPaidUpCompanies = 'LowPaidUpCompanies',
  ProfitReducedFromLastYear = 'ProfitReducedFromLastYear',
  TBA = 'TBA',
}

export enum FundamentalScreening {
  ShariahCompliantHalalInvestableShare = 'ShariahCompliantHalalInvestableShare',
  MarginShare = 'MarginShare',
}
